import { superAdminApi, superAdminRequest } from './superAdminApi';

export const superAdminService = {
  // Dashboard
  getDashboard: () =>
    superAdminRequest(() => superAdminApi.get('/super-admin/dashboard')),

  // Companies
  getCompanies: (params = {}) =>
    superAdminRequest(() => superAdminApi.get('/super-admin/companies', { params })),

  getCompanyDetail: (id) =>
    superAdminRequest(() => superAdminApi.get(`/super-admin/companies/${id}`)),

  toggleCompanyActive: (id) =>
    superAdminRequest(() => superAdminApi.put(`/super-admin/companies/${id}/toggle-active`)),

  updateCompanyPlan: (id, planId) =>
    superAdminRequest(() => superAdminApi.put(`/super-admin/companies/${id}/plan`, { planId })),

  // Invoices
  getInvoices: (params = {}) =>
    superAdminRequest(() => superAdminApi.get('/super-admin/invoices', { params })),

  resendInvoice: (id) =>
    superAdminRequest(() => superAdminApi.post(`/super-admin/invoices/${id}/resend`)),

  downloadInvoice: async (id) => {
    const response = await superAdminApi.get(`/super-admin/invoices/${id}/download`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Payment Codes
  getPaymentCodes: (params = {}) =>
    superAdminRequest(() => superAdminApi.get('/super-admin/payment-codes', { params })),

  generatePaymentCode: (data) =>
    superAdminRequest(() => superAdminApi.post('/super-admin/payment-codes/generate', data)),

  updatePaymentCodeStatus: (id, status) =>
    superAdminRequest(() => superAdminApi.put(`/super-admin/payment-codes/${id}/status`, { status })),

  // Signup Attempts
  getSignupAttempts: (params = {}) =>
    superAdminRequest(() => superAdminApi.get('/super-admin/signup-attempts', { params })),

  getSignupAttemptStats: () =>
    superAdminRequest(() => superAdminApi.get('/super-admin/signup-attempts/stats')),

  // Usage Stats
  getUsageStats: () =>
    superAdminRequest(() => superAdminApi.get('/super-admin/usage-stats')),

  // Template Library
  getTemplateLibrary: (params = {}) =>
    superAdminRequest(() => superAdminApi.get('/super-admin/template-library', { params })),

  createTemplateLibrary: (data) =>
    superAdminRequest(() => superAdminApi.post('/super-admin/template-library', data)),

  updateTemplateLibrary: (id, data) =>
    superAdminRequest(() => superAdminApi.put(`/super-admin/template-library/${id}`, data)),

  deleteTemplateLibrary: (id) =>
    superAdminRequest(() => superAdminApi.delete(`/super-admin/template-library/${id}`))
};
